import { useEffect, useState } from "react";
import { TextField, Grid, Typography, Stack } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  setApproveDialog,
  LeaveAdmin,
} from "../../../../app/slices/leaveAdminSlice";
import { LeaveStatus } from "../../../../app/slices/leaveStatusSlice";
import { SelectLeaveStatus } from "../../../../components/Selectors/SelectLeaveStatus";
import { findStatusByKind } from "../../leaveStatus";
import {
  HiOutlineCalendarDays,
  HiOutlineClipboardDocumentCheck,
} from "react-icons/hi2";
import FormDialog, {
  SectionCard,
  PlainCard,
} from "../../../../components/FormDialog";

const LeaveApproveForm = () => {
  const dispatch = useDispatch();

  const _Approve = useSelector((state) => state.leaveAdmin.approve);
  const _SearchBody = useSelector((state) => state.leaveAdmin.searchBody);
  const statusList = useSelector((state) => state.leaveStatus.data);

  const [status, setStatus] = useState(null);
  const [comments, setcomments] = useState("");

  const row = _Approve.data;

  useEffect(() => {
    if (!statusList?.length) {
      dispatch(LeaveStatus.getAll());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // The button the admin pressed picks the status, but it stays editable in
  // case the list from the API does not match the expected wording.
  useEffect(() => {
    setStatus(findStatusByKind(statusList, _Approve.kind));
  }, [statusList, _Approve.kind]);

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(
      LeaveAdmin.approve(
        row?.id,
        {
          status_id: status?.id,
          comments: comments,
        },
        _SearchBody,
      ),
    );
  };

  return (
    <FormDialog
      open={_Approve.dialog}
      onClose={() => dispatch(setApproveDialog())}
      icon={<HiOutlineCalendarDays />}
      title="تدقيق طلب الاجازة"
      subtitle="اختر حالة الطلب واكتب الملاحظات ثم احفظ"
      onSubmit={onSubmit}
      saveDisabled={!status}
    >
      <PlainCard>
        <Stack direction="column" spacing={0.5}>
          <Typography variant="body2" color="text.secondary">
            المندوب: {row?.user_name ?? ""}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            من {row?.start_date ? dayjs(row.start_date).format("YYYY-MM-DD") : ""}{" "}
            الى {row?.end_date ? dayjs(row.end_date).format("YYYY-MM-DD") : ""} -
            عدد الايام: {row?.total_days ?? ""}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            السبب: {row?.reason ?? ""}
          </Typography>
        </Stack>
      </PlainCard>

      <SectionCard
        icon={<HiOutlineClipboardDocumentCheck />}
        title="قرار الطلب"
      >
        <Grid item xs={12}>
          <SelectLeaveStatus
            required
            label="حالة الطلب"
            value={status}
            onChange={(e, newValue) => setStatus(newValue ?? null)}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            size="small"
            label="الملاحظات"
            multiline
            rows={3}
            fullWidth
            value={comments}
            onChange={(e) => setcomments(e.target.value)}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default LeaveApproveForm;
